import { Helmet } from 'react-helmet-async';

export function DmcaPage() {
  return (
    <>
      <Helmet>
        <title>DMCA - LyricsHub</title>
      </Helmet>
      <div className="max-w-3xl mx-auto">
        <h1 className="text-3xl font-bold text-text-primary mb-6">DMCA - Aviso de Eliminación</h1>
        <div className="prose prose-invert max-w-none space-y-4 text-text-secondary text-sm leading-relaxed">
          <p>
            LyricsHub respeta los derechos de propiedad intelectual. Si crees que algún contenido en
            nuestra plataforma infringe tus derechos de autor, puedes solicitar su eliminación.
          </p>

          <h2 className="text-lg font-semibold text-text-primary mt-8">Cómo Reportar</h2>
          <p>Envía un email a dmca@lyricshub.com incluyendo:</p>
          <ul className="list-disc pl-6 space-y-2">
            <li>Identificación de la obra protegida</li>
            <li>URL del contenido en LyricsHub que infringe</li>
            <li>Tu información de contacto</li>
            <li>Declaración de buena fe</li>
            <li>Firma física o electrónica</li>
          </ul>

          <h2 className="text-lg font-semibold text-text-primary mt-8">Tiempo de Respuesta</h2>
          <p>
            Procesamos todas las solicitudes DMCA en un plazo máximo de 48 horas laborables. El
            contenido será retirado mientras se investiga la reclamación.
          </p>
        </div>
      </div>
    </>
  );
}
